module.exports = __webpack_public_path__ + "static/icon-memberships-229884611539421b86112af2303f3409.png";